import data from "../../.sourceflow/sector.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const sector_helper = new CollectionHelper(data);
